import axios from "axios";
import { getToken } from "./auth";

const api = axios.create({
  baseURL: process.env.VUE_APP_PROD_BACKEND_API_URL,
});
api.interceptors.request.use(async (api_config) => {
  const token = getToken();
  if (token) api_config.headers.Authorization = `Bearer ${token}`;
  return api_config;
});
export default api;
